import '../App.css';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from "../components/Layout";

function Logout() {
    localStorage.setItem('isLoggedIn', false);
    const navigate = useNavigate();

    useEffect(() => {
      // Redirect to '/new-route' after component mounts
      navigate('/');
    }, [navigate]);

    return (
      <Layout>
        <div className="panel anim-pop">
          <span className="badge">🌿 See You Soon</span>
          <p className="hint">Swinging you back to the treehouse...</p>
        </div>
      </Layout>
    );
}

export default Logout;
